import { Box, CircularProgress, Typography } from '@mui/material';
import { useIntl } from 'react-intl';
import { Navigate } from 'react-router-dom';

import { getProjectsBasePath } from '@verantos-dev/core-constants';

import { useAnalysisProfileQuery } from '../api/useAnalysisProfileQuery';
import { useAnalysisRouteParams } from '../hooks/useAnalysisRouteParams';
import { getAnalysisVersionPath } from '../routes';

// Resolves the unversioned URL to the versioned one the detail page expects.
// Hit by typed URLs / external deep links; project-artifact-list navigations
// already carry the latest version id and bypass this resolver.
export const AnalysisVersionResolverPage = () => {
  const { formatMessage } = useIntl();
  const { projectId, analysisProfileId } = useAnalysisRouteParams();

  const { data, error, isLoading } = useAnalysisProfileQuery({
    projectId,
    analysisProfileId,
  });

  const latestVersionId = data?.data.latestAnalysisVersionId;

  if (latestVersionId) {
    return (
      <Navigate
        replace
        to={getAnalysisVersionPath(projectId, analysisProfileId, latestVersionId)}
      />
    );
  }

  if (error && !isLoading) {
    return (
      <Box
        data-testid="analysis-version-resolver-error"
        sx={{ padding: 3, display: 'flex', flexDirection: 'column', gap: 1 }}
      >
        <Typography variant="subtitle1" color="error">
          {formatMessage({ id: 'analysisDetail.versionResolver.errorTitle' })}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {formatMessage({ id: 'analysisDetail.versionResolver.errorBody' })}{' '}
          <a href={getProjectsBasePath()}>
            {formatMessage({ id: 'analysisDetail.versionResolver.backToProjects' })}
          </a>
          .
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      data-testid="analysis-version-resolver-loading"
      sx={{ display: 'flex', justifyContent: 'center', paddingY: 6 }}
    >
      <CircularProgress size={24} />
    </Box>
  );
};
